import { Component, Input, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UserAccountMenuComponent } from '../user-account-menu/user-account-menu.component';
import { LanguageSelectComponent } from '../language-select/language-select.component';
import { Observable, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { GlobalSearchOverlayService } from '../../service/global-search-overlay.service';

@Component({
    selector: 'app-toolbar-menu',
    templateUrl: './toolbar-menu.component.html',
    styleUrls: ['./toolbar-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToolbarMenuComponent implements OnInit, OnDestroy {
  @ViewChild(UserAccountMenuComponent, { static: true }) userAccountMenu: UserAccountMenuComponent;
  @ViewChild(LanguageSelectComponent, { static: true }) languageMenu: LanguageSelectComponent;
  @Input() openNavigation: () => void;
  @Input() isAdmin$?: Observable<boolean>;
  private routeSubscription?: Subscription;
  private featureActiveSubscription?: Subscription;

  isSystemOverviewRoute = false;
  isGlobalSearchActive = false;

  constructor(
    private router: Router,
    private globalSearchOverlayService: GlobalSearchOverlayService
  ) {}

  ngOnInit() {
    this.updateGlobalSearchVisibility(this.router.url);
    this.featureActiveSubscription = this.globalSearchOverlayService.featureActive$.subscribe(isActive => {
      this.isGlobalSearchActive = isActive;
    });
    this.routeSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.updateGlobalSearchVisibility(event.urlAfterRedirects);
      }
    });
  }

  ngOnDestroy() {
    this.featureActiveSubscription?.unsubscribe();
    this.routeSubscription?.unsubscribe();
  }

  closeUserAccountMenu() {
    this.userAccountMenu?.close();
  }

  closeLanguageMenu() {
    this.languageMenu?.close();
  }

  closeMenus() {
    this.closeUserAccountMenu();
    this.closeLanguageMenu();
  }

  openGlobalSearch() {
    this.closeMenus();
    this.globalSearchOverlayService.open();
  }

  handleOpenNavigation() {
    this.openNavigation?.();
  }

  private updateGlobalSearchVisibility(url: string) {
    const normalizedUrl = (url || '').split('?')[0].replace(/\/$/, '');
    this.isSystemOverviewRoute = normalizedUrl === '/dh';
  }
}
